<script>

export default {
  name: "JobHold",
  permissions: ["Modify Job"],
  props: ["job"],
  emits: ["updated"],
  components: {},
  computed: {
    daysOnHold: function () { // Calculate days on hold (if currently on hold, not historical)
      if (this.onHoldDate) {
        const onHoldDate = new Date(this.onHoldDate);
        const today = new Date();
        const diffTime = Math.abs(today - onHoldDate);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
      }
      return 0;
    }
  },
  methods: {
    loadBwfJob: function () {
      // Load BWF job data if needed
      this.$BwfApi.get("job", {job_id: this.job.ID}).then(bwfResponse => {
        if (bwfResponse) {
          this.totalDaysOnHold = bwfResponse?.days_on_hold || 0; // this gets populated by a background job
        }
      }).catch(err => {
        console.error("Error loading BWF job data:", err)
      })
    },
    placeOnHold: function () {
      this.dialog = true
    },
    removeHold: function (newState) {
      if (this.job.State === "On Hold") {
        this.saveNote( `Job taken off hold`)
        this.job2.State = newState
      }
    },
    save: function () {
      const data = {
        Job: {
          ID: this.job.ID,
          State: "On Hold"
        }
      }
      this.$WfmApi.put("job.api/state", data).then(() => {
        const note = `Job placed on hold\n ${this.holdReason}`
        this.saveNote(note)
        this.$emit("updated")
      })
    },
    loadNotes: function () {
      return this.$WfmApi.get("job.api/get/" + this.job.ID + "/customfield", {})
          .then((response) => {
            const customFields = this.$ensureArray(response.CustomFields.CustomField)
            const notesField = customFields.find(field => field.UUID === this.notesUUID)
            return notesField ? notesField.Text : ""
          })
    },
    saveNote: function (newNote) {
      const today = new Date()
      const date = today.toISOString().substr(0, 10)
      const newNotes = `${date} - ${newNote}\n` + this.notes
      const customFields = {CustomFields: {CustomField: [{"UUID": this.notesUUID, Text: newNotes}]}}
      this.$WfmApi.put("job.api/update/" + this.job.ID + "/customfield", customFields).then(() => {
        this.holdReason = ""
        this.dialog = false
      })
    },
    extractOnHoldDate: function (note) {
      // use regex to get the date from the job's onHoldDate string in the notes
      const regex = /(\d{4}-\d{2}-\d{2}) - Job placed on hold/;
      const match = note.match(regex);
      if (match) {
        this.onHoldDate = match[1];
      } else {
        this.onHoldDate = null;
      }
    },
  },
  mounted() {
    this.job2 = this.$clone(this.job)
    this.loadBwfJob()
    this.loadNotes().then(notes => {
      this.notes = notes || "";
      this.extractOnHoldDate(notes)
    })
  },
  data() {
    return {
      notesUUID: "9c483d6b-43d9-4201-9eed-01908dd712c2",
      job2: {},
      dialog: false,
      notes: "",
      onHoldDate: null,
      holdReason: "",
      totalDaysOnHold: 0,

    }
  }
}
</script>


<template>
  <div class="display-inline">
    <div v-if="totalDaysOnHold > 0">Job has spent a total of {{ totalDaysOnHold }} days on hold</div>

    <div v-if="job2.State === 'On Hold'">
      On hold since {{ onHoldDate }} ({{ daysOnHold }} days)
    </div>
    <div v-else>
      <v-btn @click="placeOnHold" x-small color="primary" class="mr-1">Place on hold</v-btn>
    </div>

    <v-dialog v-model="dialog" width="500px" ref="dialog">
      <v-card>
        <v-card-title class="headline">Place Job on Hold</v-card-title>
        <v-card-text>
          <v-textarea v-model="holdReason" label="Why is the job being placed on hold?" rows="4"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="save" class="full-width" rounded>Place on hold</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>